import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/bank/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  listAll({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/bank/listAll`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findQuestionByBankId({ commit }, params) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/examination/bank/findQuestionByBankId',
        params: params
      }).then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/bank/save`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/bank/findById?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  remove({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/bank/remove?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  batchRemove({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/bank/batchRemove`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  importQuestion({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/examination/bank/importQuestion',
        method: 'post',
        data: params,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
